import { Store } from 'vuex'
import modules from './modules'

export default new Store({
  modules
})